import { callMethodOnKeydown, isTyping } from '../helpers'
import { state } from '../map_state/state'
import { viewport } from '../map_state/viewport'
import { addSensorTool } from './add_sensor_tool'
import { cropTool } from './crop_tool'
import { dragTool } from './drag_tool'
import { linearFlowTool } from './linear_flow_tool'
import { pathTracerTool } from './path_tracer_tool'
import { pointDistanceTool } from './point_distance_tool'

class PanTool {
  constructor () {
    this.element = document.getElementById('mct-pan')
    this.bindEvents()
  }

  bindEvents () {
    this.activate = this.activate.bind(this)
    this.onPointerDown = this.onPointerDown.bind(this)
    this.onPointerMove = this.onPointerMove.bind(this)
    this.onPointerUp = this.onPointerUp.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
    this.element.addEventListener('click', this.activate)
    document.addEventListener('keydown', this.onKeyDown)
  }

  unBindEvents () {
    this.element.removeEventListener('click', this.activate)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  activate (mode = true) {
    this.active = !state.panMode && mode
    if (this.active) {
      if (state.cropMode) cropTool.stopCrop()
      else if (state.dragMode) dragTool.activate(false)
      else if (state.addSensorMode) addSensorTool.activate(false)
      else if (state.linearFlowMode) linearFlowTool.activate(false)
      else if (state.tracerMode) pathTracerTool.enableMode(state.tracerMode, false)
      else if (state.linearFlowMode) linearFlowTool.activate(false)
      if (state.pointDistanceMode) pointDistanceTool.activate(false)
      viewport.element.style.cursor = 'grab'
      this.element.classList.add('selected')
      state.panMode = true
      viewport.element.addEventListener('pointerdown', this.onPointerDown)
      viewport.element.addEventListener('pointermove', this.onPointerMove)
      viewport.element.addEventListener('pointerup', this.onPointerUp)
      viewport.element.addEventListener('pointerleave', this.onPointerUp)
    } else {
      viewport.element.style.cursor = 'default'
      this.element.classList.remove('selected')
      state.panMode = false
      viewport.element.removeEventListener('pointerdown', this.onPointerDown)
      viewport.element.removeEventListener('pointermove', this.onPointerMove)
      viewport.element.removeEventListener('pointerup', this.onPointerUp)
      viewport.element.removeEventListener('pointerleave', this.onPointerUp)
    }
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === 'n') { callMethodOnKeydown(e.target, this.activate) }
  }

  onPointerDown (e) {
    this.start = {
      x: e.clientX,
      y: e.clientY,
      scrollLeft: viewport.element.scrollLeft,
      scrollTop: viewport.element.scrollTop
    }
    this.dragging = true
    viewport.element.style.cursor = 'grabbing'
  }

  onPointerMove (e) {
    if (this.dragging) {
      const dx = e.clientX - this.start.x
      const dy = e.clientY - this.start.y
      viewport.element.scrollLeft = this.start.scrollLeft - dx
      viewport.element.scrollTop = this.start.scrollTop - dy
    }
  }

  onPointerUp (_e) {
    this.start = null
    this.dragging = false
    viewport.element.style.cursor = 'grab'
  }
}

export let panTool = null

export function initPanTool () {
  panTool = new PanTool()
  return panTool
}
